// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w7Wf","col":"styles_col__1u_Mp"};